import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  .tableClassname .ant-table-thead > tr > th.limit-column {
    font-weight: 800;
  }
`;
